import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { RequestsService as RequestsService } from './requests.abstract.service';
import { Request, GetRequests } from './requests.model';

@Injectable({
    providedIn: 'root',
})
export class RequestsImplService implements RequestsService {
    private baseUrl: string = environment.API_GATEWAY_URL;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    public getRequests(page: number = 1, pageSize: number = 10) {
        return this.http.get(`${this.baseUrl}/requests/admin?page=${page + 1}&limit=${pageSize}`).pipe(map((response: any) => response as GetRequests));
    }

    public getRequestDetail(id: string) {
        return this.http.get(`${this.baseUrl}/requests/admin/${id}`).pipe(map((response: any) => response as Request));
    }

    public modifyRequest(id: string, payload: any) {
        return this.http.patch(`${this.baseUrl}/requests/admin/${id}`, payload).pipe(map((response: any) => response as Request));
    }
}

export const REQUESTS_SERVICE_PROVIDER = {
    provide: RequestsService,
    useClass: RequestsImplService,
};
